import React, { useEffect, useState } from 'react';
import _, { isEmpty, mapValues } from 'lodash';
import { motion } from 'framer-motion';
import ReCAPTCHA from 'react-google-recaptcha';
import BoxedContainer from './layouts/BoxedContainer';
import Form from '../helpers/form';

function validateFormValues(value, required, pattern) {
  if (required && Array.isArray(value)) {
    return value.length > 0;
  }
  if (required && typeof value === 'string') {
    return pattern ? value.match(pattern) : !!value.trim().length;
  }
  return true;
}

function FormField({ data, handleChange, handleErrorText, inputValues, dir }) {
  const alias = _.get(data, 'alias', '');
  const required = _.get(data, 'required', '');
  const type = _.get(data, 'type', '');
  const fieldType = _.get(data, 'settings.fieldType', '');
  const placeholder = _.get(data, 'settings.placeholder', '');
  const pattern = _.get(data, 'settings.pattern', '');
  const maximumLength = _.get(data, 'settings.maximumLength', '');
  const errMsg = _.get(data, 'settings.patternInvalidErrorMessage', '');
  const caption = _.get(data, 'caption', '');
  const options = _.get(data, 'preValues', []);

  const handleCheckboxChange = (event) => {
    const { name, value, checked } = event.target;
    const updatedCheckbox = inputValues[name] ? [...inputValues[name].value] : [];
    if (checked) {
      updatedCheckbox.push(value);
    } else {
      const index = updatedCheckbox.indexOf(value);
      if (index > -1) {
        updatedCheckbox.splice(index, 1);
      }
    }
    handleChange({ target: { name, value: updatedCheckbox, required } });
  };

  const handleRadioBtnChange = (event) => {
    const { name, value } = event.target;
    handleChange({ target: { name, value, required: event.target.required } });
  };

  if (type === 'text') {
    switch (fieldType) {
      case 'tel':
        return (
          <div className="w-full h-auto relative flex flex-col gap-3 lg:gap-4 justify-between">
            <label
              data-required={required}
              className="transition-all duration-300 text-carbonGrey 
              data-[required=true]:after:inline data-[required=true]:after:content-['*'] 
              text-clamp13to18 
          ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium leading-1.75">
              {caption}
            </label>
            <input
              id={alias}
              name={alias}
              type="tel"
              required={required}
              className="w-full outline-[transparent] bg-white px-4 py-1 md:py-3.5 outline-none 
              placeholder:text-clamp12to15 text-clamp12to15 h-10 md:h-[55px] 
              placeholder:!text-[#333]"
              placeholder={placeholder}
              value={inputValues[alias].value}
              onChange={(event) => handleChange(event, pattern)}
            />
            {errMsg && (
              <span
                data-hide={Boolean(handleErrorText(inputValues[alias]))}
                className="text-xxs text-watermelon absolute -bottom-5 ltr:left-0 rtl:right-0 
                data-[hide=true]:hidden data-[hide=false]:inline">
                {errMsg}
              </span>
            )}
          </div>
        );
      case 'email':
        return (
          <div className="w-full h-auto relative flex flex-col gap-3 lg:gap-4 justify-between">
            <label
              data-required={required}
              className="transition-all duration-300 text-carbonGrey text-clamp13to18 
              data-[required=true]:after:inline data-[required=true]:after:content-['*'] 
          ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium leading-1.75">
              {caption}
            </label>
            <input
              id={alias}
              name={alias}
              type="email"
              required={required}
              className="w-full outline-[transparent] bg-white px-4 py-1 md:py-3.5 outline-none 
              placeholder:text-clamp12to15 text-clamp12to15 h-10 md:h-[55px] 
              placeholder:!text-[#333]"
              placeholder={placeholder}
              value={inputValues[alias].value}
              onChange={(event) => handleChange(event, pattern)}
            />
            {errMsg && (
              <span
                data-hide={Boolean(handleErrorText(inputValues[alias]))}
                className="text-xxs text-watermelon absolute -bottom-5 ltr:left-0 
                rtl:right-0 data-[hide=true]:hidden data-[hide=false]:inline">
                {errMsg}
              </span>
            )}
          </div>
        );
      default:
        return (
          <div
            className={`${alias === 'company' ? 'lg:col-span-2 lg:py-5' : ''} w-full h-auto 
            relative flex flex-col gap-3 lg:gap-4 justify-between`}>
            <label
              data-required={required}
              className="transition-all duration-300 text-carbonGrey text-clamp13to18 
              data-[required=true]:after:inline data-[required=true]:after:content-['*'] 
          ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium leading-1.75">
              {caption}
            </label>
            <input
              id={alias}
              name={alias}
              type="text"
              placeholder={placeholder}
              required={required}
              className="w-full outline-[transparent] bg-white px-4 py-1 md:py-3.5 outline-none 
              placeholder:text-clamp12to15 text-clamp12to15 h-10 md:h-[55px] 
              placeholder:!text-[#333]"
              value={inputValues[alias].value}
              onChange={(event) => handleChange(event, pattern)}
            />
            {errMsg && (
              <span
                data-hide={Boolean(handleErrorText(inputValues[alias]))}
                className="text-xxs text-watermelon absolute -bottom-5 ltr:left-0 
                rtl:right-0 data-[hide=true]:hidden data-[hide=false]:inline">
                {errMsg}
              </span>
            )}
          </div>
        );
    }
  }
  if (type === 'textarea') {
    return (
      <div
        className={`${alias === 'aboutNewBusiness' ? 'py-6' : ''} 
      lg:col-span-2 w-full h-auto relative flex flex-col gap-3 lg:gap-4 
      justify-between`}>
        <label
          data-required={required}
          className="transition-all duration-300 text-carbonGrey 
          data-[required=true]:after:inline data-[required=true]:after:content-['*'] 
          text-clamp13to18 
          ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium leading-1.75">
          {caption}
        </label>
        <textarea
          id={alias}
          name={alias}
          required={required}
          placeholder={placeholder}
          maxLength={maximumLength}
          className="w-full h-auto resize-none min-h-[7.5rem] lg:min-h-[215px] bg-white px-4 py-3.5 
          outline-none placeholder:text-clamp12to15 text-clamp12to15 placeholder:!text-[#333]"
          value={inputValues[alias].value}
          onChange={(event) => handleChange(event, pattern)}
        />
      </div>
    );
  }

  if (type === 'select') {
    return (
      <div
        className={`
        ${alias === 'inquiryType' || alias === 'registeredPartner' ? 'lg:col-span-2' : ''} 
        ${alias === 'inquiryType' ? 'lg:pb-6' : ''} 
        ${alias === 'registeredPartner' ? 'lg:pt-6' : ''} 
      w-full h-auto relative flex flex-col gap-3 lg:gap-4 select-field justify-between`}>
        <label
          data-required={required}
          className="transition-all duration-300 text-carbonGrey data-[required=true]:after:inline 
          data-[required=true]:after:content-['*'] text-clamp13to18 
          ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium leading-1.75">
          {caption}
        </label>
        <div
          className={`
          ${
            alias === 'inquiryType' || alias === 'registeredPartner'
              ? 'lg:max-w-[calc(50%-16px)]'
              : ''
          } relative`}>
          <select
            id={alias}
            name={alias}
            required={required}
            className="w-full outline-[transparent] bg-white px-4 py-1 md:py-3.5 outline-none 
            placeholder:text-clamp12to15 text-clamp12to15 h-10 md:h-[55px] !text-[#333]"
            value={inputValues[alias].value}
            onChange={(event) => handleChange(event, pattern)}>
            <option value="">{dir === 'rtl' ? 'يرجى التحديد' : 'Please select'}</option>
            {options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <svg
            width="8"
            height="5"
            viewBox="0 0 8 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute top-[18px] md:top-[25px] rtl:left-4 ltr:right-4">
            <path
              d="M7 1L4 4L1 1"
              stroke="#333333"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        {errMsg && (
          <span
            data-hide={Boolean(handleErrorText(inputValues[alias]))}
            className="text-xxs text-watermelon absolute -bottom-5 ltr:left-0 
            rtl:right-0 data-[hide=true]:hidden data-[hide=false]:inline">
            {errMsg}
          </span>
        )}
      </div>
    );
  }

  if (type === 'checkboxList') {
    return (
      <div
        className="lg:col-span-2 w-full h-auto relative flex flex-col gap-4 md:gap-[30px]"
        id={alias}>
        <label
          data-required={required}
          className="transition-all duration-300 text-carbonGrey data-[required=true]:after:inline 
        data-[required=true]:after:content-['*'] text-clamp13to18
          ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium leading-1.75">
          {caption}
        </label>
        <div className="relative overflow-hidden">
          {options.map((option, index) => (
            <div
              key={index}
              className="md:inline-flex relative ltr:mr-5 rtl:ml-5 mb-2 lg:mb-6 ltr:pl-8 rtl:pr-8">
              <input
                id={`${alias}-${index}`}
                name={alias}
                type="checkbox"
                value={option}
                checked={inputValues[alias].value.includes(option)}
                onChange={handleCheckboxChange}
                className="checkbox absolute ltr:left-0 rtl:right-0 opacity-0"
              />
              <label
                htmlFor={`${alias}-${index}`}
                className="inline-block text-clamp12to15 after:content[] after:block after:w-5 
                after:h-5 after:md:w-6 after:md:h-6 after:bg-white after:absolute pt-1
                ltr:after:left-0 rtl:after:right-0 after:top-0 cursor-pointer min-h-[24px]">
                {option}
              </label>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'radio') {
    return (
      <div
        className="lg:col-span-2 w-full h-auto relative flex flex-col gap-4 md:gap-[30px]"
        id={alias}>
        <label
          data-required={required}
          className="transition-all duration-300 text-carbonGrey data-[required=true]:after:inline 
          data-[required=true]:after:content-['*'] text-clamp13to18 
          ltr:font-URWDINMedium rtl:font-GESSTwoDWTCMedium leading-1.75">
          {caption}
        </label>
        <div className="relative overflow-hidden">
          {options.map((option, index) => (
            <div
              key={index}
              className="md:inline-flex relative ltr:mr-5 rtl:ml-5 mb-2 lg:mb-6 
              ltr:pl-10 rtl:pr-10">
              <input
                id={`${alias}-${index}`}
                name={alias}
                type="radio"
                value={option}
                checked={inputValues[alias].value === option}
                onChange={handleRadioBtnChange}
                className="radio absolute ltr:left-0 rtl:right-0 opacity-0"
              />
              <label
                htmlFor={`${alias}-${index}`}
                className="inline-block text-clamp12to15 after:content[] after:block after:w-5 
                after:h-5 after:md:w-6 after:md:h-6 after:bg-white after:absolute pt-1 
                after:rounded-full ltr:after:left-0 rtl:after:right-0 after:top-0 cursor-pointer 
                min-h-[24px]">
                {option}
              </label>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'dataConsent') {
    return (
      <div
        className="lg:col-span-2 py-4 w-full relative [&>a]:underline hover:[&>a]:no-underline 
        text-[14px] lg:text-[15px]"
        dangerouslySetInnerHTML={{ __html: data.settings.acceptCopy }}
      />
    );
  }

  if (type === 'recaptcha2') {
    return (
      <div className="mt-7 md:mt-0">
        <ReCAPTCHA
          sitekey="6Lf79SkhAAAAAEoDRLq9udlZsK1gmjdKIPbGCVzE"
          // onChange={(event) => handleChange(event, pattern)}
          onChange={(value) =>
            handleChange({
              target: { name: 'recaptcha', value, required: true },
            })
          }
        />
      </div>
    );
  }

  return null;
}

export default function FreeZoneForm({ data, dir }) {
  const [formValues, setFormValues] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [submitted, setSubmitted] = useState({ message: '', status: false });
  const [registeredPartner, setRegisteredPartner] = useState('');
  const [inquiryType, setInquiryType] = useState('');
  const title = _.get(data, 'title', '');
  const text = _.get(data, 'text', '');
  const formId = _.get(data, 'formId', '');
  const isRegisterYourInterest =
    typeof window !== 'undefined' && _.includes(window.location.pathname, 'register-your-interest');

  const valYes = dir === 'rtl' ? 'نعم' : 'Yes';

  const valNewBusiness = dir === 'rtl' ? 'تأسيس شركة جديدة' : 'New business setup';

  const valOfficeSpace =
    dir === 'rtl' ? 'المساحات المكتبية في مركز دبي التجاري العالمي' : 'Office space in DWTC';

  useEffect(() => {
    const form = new Form(formId);

    form
      .get()
      .then((res) => {
        setFormValues(_.get(res, 'fields', []));
        setSubmitted({ ...submitted, message: res.messageOnSubmit });
      })
      .catch((err) => console.log(err));
  }, []);

  const handleInitReset = () => {
    if (!isEmpty(formValues)) {
      const values = {};
      _.forEach(formValues, (item) => {
        values[item.alias] = { value: '', validation: false, required: item.required };
      });
      setInputValues(values);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleInitReset();
  }, [formValues]);

  useEffect(() => {
    const renderedFields = formValues.filter((item) => {
      if (
        (item.alias === 'companyName' ||
          item.alias === 'companyID' ||
          item.alias === 'companyEmailAddress') &&
        registeredPartner !== valYes
      ) {
        return false;
      }

      if (
        (item.alias === 'officeSolutionRequired' || item.alias === 'timeline') &&
        inquiryType !== valNewBusiness &&
        inquiryType !== valOfficeSpace
      ) {
        return false;
      }

      if (
        (item.alias === 'aboutNewBusiness' || 
          item.alias === 'licenseType') &&
        inquiryType !== valNewBusiness
      ) {
        return false;
      }

      return true;
    });

    //console.log('Rendered Fields:', renderedFields);

    const filtered = renderedFields.filter(
      (item) => item.required && !inputValues[item.alias]?.validation,
    );

    //console.log('Filtered Fields:', filtered);

    if (filtered.length > 0) setDisableSubmit(true);
    else setDisableSubmit(false);
  }, [inputValues, formValues, registeredPartner, inquiryType]);

  const handleChange = (event, pattern) => {
    const { name, value, required, type } = event.target;
    let newValue;

    if (type === 'radio') {
      const set = new Set(inputValues[name].value);
      if (set.has(value)) {
        set.delete(value);
      } else {
        set.add(value);
      }
      newValue = Array.from(set);
    } else {
      newValue = value;
    }

    setInputValues((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: newValue,
        validation: validateFormValues(newValue, required, pattern),
      },
    }));

    if (name === 'registeredPartner') {
      setRegisteredPartner(value);
    }

    if (name === 'inquiryType') {
      setInquiryType(value);
    }
  };

  const handleErrorText = (field) => {
    if (field.value) return field.validation;
    return true;
  };

  const handleSubmit = () => {
    const form = new Form(formId);
    const values = mapValues(inputValues, 'value');
    setIsLoading(true);
    form
      .post(values)
      .then(() => {
        const val = {};
        formValues.forEach((item) => {
          val[item.alias] = { value: '', validation: false, required: item.required };
        });
        setInputValues(val);
        setSubmitted({ ...submitted, status: true });
        const dataLayer = window && window?.dataLayer ? window.dataLayer : [];
        dataLayer.push({ event: 'Enquery_Form_Trigger' });
      })
      .catch((err) => console.log(err));
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className={`py-[50px] md:py-[110px] ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight 
        ${isRegisterYourInterest ? 'bg-[#F2F2F2]' : 'bg-[#f7f7f7]'}
        `}>
      <BoxedContainer className="min-h-[80vh] md:min-h-[50vh]">
        <div
          className="text-center grid grid-cols-1 gap-5 lg:gap-6 col-span-12 
        lg:col-span-5 grid-flow-row auto-rows-min">
          <div
            className="[&>*>strong]:!font-URWDINBold [&>*>strong]:!font-bold 
            child:!text-clamp20to40 child:!font-URWDINMedium child:!font-medium 
            child:ltr:leading-1.125 child:rtl:leading-1.3 child:rtl:md:leading-1.2 
            child:m-0 child:text-[#231F20]"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <div className="w-[70px] h-[2px] bg-red my-px mx-auto" />

          {text !== '' ? (
            <div
              className="child:text-clamp12to18 child:ltr:!font-URWDINRegular 
              child:rtl:!font-GESSTwoDWTCLight child:leading-1.75 
              child:m-0 grid grid-cols-1 gap-7 child:text-[#4a4a4a] md:pb-12 pb-10 pt-2 md:pt-0"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          ) : (
            <div>&nbsp;</div>
          )}
        </div>

        {isLoading ? (
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full">
            {submitted.status ? (
              <span
                className="flex text-3xl w-full text-center -translate-y-8"
                id="success-message">
                {submitted.message}
              </span>
            ) : (
              <div className="relative">
                <div
                  className="border-t-dull-gold-100 ease-linear rounded-full border-8 border-t-8 
                  h-30 md:h-48 w-30 md:w-48 mx-auto border-gray-200 animate-spinner 
                  border-dull-gold-40"
                />
                <span
                  className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 
                  text-sm md:text-lg uppercase">
                  {dir === 'rtl' ? 'جار التحميل' : 'Loading'}...
                </span>
              </div>
            )}
          </div>
        ) : (
          <form className="w-full flex flex-col gap-7.5 lg:gap12.5">
            <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-7.5">
              {_.map(formValues, (item) => {
                if (
                  (item.alias === 'companyName' ||
                    item.alias === 'companyID' ||
                    item.alias === 'companyEmailAddress') &&
                  registeredPartner !== valYes
                ) {
                  return null;
                }

                if (
                  (item.alias === 'officeSolutionRequired' || item.alias === 'timeline') &&
                  inquiryType !== valNewBusiness &&
                  inquiryType !== valOfficeSpace
                ) {
                  return null;
                }

                if (
                  (item.alias === 'aboutNewBusiness' || 
                    item.alias === 'licenseType') &&
                  inquiryType !== valNewBusiness
                ) {
                  return null;
                }

                return (
                  <FormField
                    key={item.alias}
                    data={item}
                    dir={dir}
                    handleChange={handleChange}
                    handleErrorText={handleErrorText}
                    inputValues={inputValues}
                  />
                );
              })}
            </div>
            <button
              type="button"
              className="w-full md:w-[170px] flex justify-center items-center 
              rounded-[48px] bg-[#CE445B] text-white uppercase ltr:font-URWDINBold 
              rtl:font-GESSTwoDWTCMedium ltr:tracking-[0.96px] leading-1.5 md:leading-1.25 
              min-h-[36px] md:h-[51px] text-center px-6 py-2 md:py-5
              rtl:text-[12px] ltr:text-[11px] rtl:md:text-[16px] ltr:md:text-[15px] 
              rtl:lg:text-[18px]
              pt-[10px] md:pt-6 hover:bg-[#B53B50] duration-300 disabled:opacity-50 
              disabled:pointer-events-none"
              onClick={handleSubmit}
              disabled={disableSubmit}>
              {dir === 'rtl' ? 'إرسال' : 'Submit'}
            </button>
          </form>
        )}
      </BoxedContainer>
    </motion.section>
  );
}
